import * as Bowser from 'bowser';

const WEB = 'AUDIO_TYPE_WEB';
const HTML5 = 'AUDIO_TYPE_HTML5';

class SoundUnlock {
  private dataBase64: string = '';

  private audioContext: any = null;

  private unlockedTypes: Array<string> = [];

  public init = (): void => {
    if (typeof window === 'undefined') {
      return;
    }

    const AudioContext = (window as any).AudioContext || (window as any).webkitAudioContext || false;

    const browser = Bowser.getParser(window.navigator.userAgent);
    const isIOS = browser.getOSName(true) === 'ios';

    if (!isIOS || !AudioContext) {
      return;
    }

    // eslint-disable-next-line max-len
    this.dataBase64 = 'data:audio/mp3;base64,//MkxAAHiAICWABElBeKPL/RANb2w+yiT1g/gTok//lP/W/l3h8QO/OCdCqCW2Cw//MkxAQHkAIWUAhEmAQXWUOFW2dxPu//9mr60ElY5sseQ+xxesmHKtZr7bsqqX2L//MkxAgFwAYiQAhEAC2hq22d3///9FTV6tA36JdgBJoOGgc+7qvqej5Zu7/7uI9l//MkxBQHAAYi8AhEAO193vt9KGOq+6qcT7hhfN5FTInmwk8RkqKImTM55pRQHQSq//MkxBsGkgoIAABHhTACIJLf99nVI///yuW1uBqWfEu7CgNPWGpUadBmZ////4sL//MkxCMHMAH9iABEmAsKioqKigsLCwtVTEFNRTMuOTkuNVVVVVVVVVVVVVVVVVVV//MkxCkECAUYCAAAAFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV';
    this.audioContext = new AudioContext();
    this.unlockedTypes = [];

    window.addEventListener('mousedown', this.handleMouseDown);
  };

  private unlock = (): void => {
    const isUnlocked: boolean = this.unlockedTypes.includes(WEB) && this.unlockedTypes.includes(HTML5);

    if (isUnlocked) {
      return;
    }

    const buffer = this.audioContext?.createBuffer(1, 1, 22050);
    const source = this.audioContext?.createBufferSource();
    source.buffer = buffer;
    source.connect(this.audioContext?.destination);
    source.onended = this.handleAudioEnded.bind(this, WEB);
    source.start();

    const tag = document.createElement('audio');
    tag.controls = false;
    tag.preload = 'auto';
    tag.loop = false;
    tag.src = this.dataBase64;
    tag.onended = this.handleAudioEnded.bind(this, HTML5);
    tag?.play()
      // eslint-disable-next-line no-console
      ?.then(() => { console.log('play success'); })?.catch((reason) => { console.log('play failed', reason); });
  };

  private handleMouseDown = (): void => {
    this.unlock();
  };

  private handleAudioEnded = (audioType: string): void => {
    this.unlockedTypes.push(audioType);
    const isUnlocked: boolean = this.unlockedTypes.includes(WEB) && this.unlockedTypes.includes(HTML5);
    if (isUnlocked) {
      window.removeEventListener('mousedown', this.handleMouseDown);
    }
  };
}

export default new SoundUnlock();
